import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { SegmentedControl } from "@msuite/ui/segmented-control";
import type { GetMyIncomingInvoiceApprovalsQuerySchema } from "@msuite/utils/schemas";

type MyApprovalsFilter = GetMyIncomingInvoiceApprovalsQuerySchema["state"];

/** Props Interface */
interface MyApprovalsFilterPickerProps {
	value: MyApprovalsFilter;
	onChange: (value: MyApprovalsFilter) => void;
}

export function MyApprovalsFilterPicker({ value, onChange }: MyApprovalsFilterPickerProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<SegmentedControl
			value={value}
			items={[
				{
					label: t("incoming_invoices.approvals_filter.pending"),
					value: "pending",
					cyId: "my-approvals-filter-pending",
					leftIcon: (
						<Icon
							name="Clock"
							stroke="var(--color-amber-500)"
						/>
					),
				},
				{
					label: t("incoming_invoices.approvals_filter.decided"),
					value: "decided",
					cyId: "my-approvals-filter-decided",
					leftIcon: (
						<Icon
							name="CheckCheck"
							stroke="var(--color-emerald-500)"
						/>
					),
				},
			]}
			onChange={(next) => onChange(next as MyApprovalsFilter)}
		/>
	);
}
